import { I18nComponente } from "@/types/gerais"

export const ONovaAtividadei18n: I18nComponente = {
  "pt-BR": {
    naoHaNenhumaAtividadeNesteProjeto: "não há nenhuma atividade neste projeto",
    adicionarAtividades: "adicionar atividades",
    codigosRepetidos: "Códigos repetidos",
    atividadesNaoPodemPossuirMesmoCodigo: "Atividades não podem possui o mesmo código."
  },
  "es-CO": {
    naoHaNenhumaAtividadeNesteProjeto: "no hay ninguna actividad en este proyecto",
    adicionarAtividades: "agregar actividades",
    codigosRepetidos: "Códigos repetidos",
    atividadesNaoPodemPossuirMesmoCodigo: "Las actividades no pueden tener el mismo código."
  }
}
